import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNullish } from '@y42/util/nullish';
import isInteger from 'lodash/isInteger';

export interface IntegerValidationError extends ValidationErrors {
  integer: true;
}

/**
 * Checks value is integer (positive or negative)
 **/
export const integerValidator: ValidatorFn = (control: AbstractControl): IntegerValidationError | null => {
  const value = control?.value;
  if (isNullish(value) || value === '') {
    return null;
  }

  if (typeof value === 'number') {
    return isInteger(value) ? null : { integer: true };
  }

  const stringValue = value.toString();
  const pattern = /^-?\d+$/;
  const valid = pattern.test(stringValue);
  return valid ? null : { integer: true };
};
